var Industry = "Settore";
var Aerospace = "Settore aerospaziale";
var Agriculture = "Agricoltura";
var Automotive = "Settore automobilistico";
var Education = "Istruzione";
var Gaming = "Videogiochi";
var Government = "Pubblica amministrazione";
var Healthcare = "SanitÃ";
var Hospitality = "Servizi alberghieri";
var Manufacturing = "Settore manifatturiero";
var Mining = "Industria mineraria";
var Other = "Altro";
var Retail = "Vendita al dettaglio";
var Telecommunications = "Telecomunicazioni";
var Travel = "Viaggi";
var industry = {
	Industry: Industry,
	Aerospace: Aerospace,
	Agriculture: Agriculture,
	Automotive: Automotive,
	"Computers & electronics": "Computer ed elettronica",
	"Consumer goods": "Beni di consumo",
	Education: Education,
	"Financial services": "Servizi finanziari",
	Gaming: Gaming,
	Government: Government,
	Healthcare: Healthcare,
	Hospitality: Hospitality,
	"Life sciences": "Settore scientifico",
	Manufacturing: Manufacturing,
	"Marketing & advertising": "Marketing e pubblicitÃ",
	"Media & entertainment": "Multimedia e intrattenimento",
	Mining: Mining,
	"Non-profit organization": "Organizzazioni no profit",
	"Oil & gas": "Settore petrolifero e dei gas",
	Other: Other,
	"Power & utilities": "Energia e servizi pubblici",
	"Professional services": "Servizi professionali",
	"Real estate & construction": "Settore immobiliare ed edilizia",
	Retail: Retail,
	"Software & internet": "Software e Internet",
	Telecommunications: Telecommunications,
	"Transportation & logistics": "Trasporti e logistica",
	Travel: Travel,
	"Wholesale & distribution": "Ingrosso e distribuzione"
};

export { Aerospace, Agriculture, Automotive, Education, Gaming, Government, Healthcare, Hospitality, Industry, Manufacturing, Mining, Other, Retail, Telecommunications, Travel, industry as default };
